var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ml-1 d-inline-block fa fa-check",
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75502 11.015L0.205017 6.46495C-0.0683389 6.1916 -0.0683389 5.74838 0.205017 5.475L1.19494 4.48505C1.4683 4.21166 1.91154 4.21166 2.1849 4.48505L5.24999 7.55012L11.8151 0.985046C12.0884 0.71169 12.5317 0.71169 12.805 0.985046L13.795 1.975C14.0683 2.24835 14.0683 2.69157 13.795 2.96495L5.74497 11.015C5.47159 11.2883 5.02837 11.2883 4.75502 11.015Z",
    fill: "#396FC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check_icon.07d56fc0385b46a8b12c1bd6c86e2e87.svg";
export { ForwardRef as ReactComponent };